import OrderManagement from "./OrderManagement";

export default OrderManagement;
